var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: _vm.xs, md: _vm.md } },
    [
      _c("w-input-number", {
        attrs: {
          fancy: "",
          value: _vm.inputValue,
          min: 1,
          max: 31,
          decimals: 0,
          "calculate-decimals": 0,
          label: _vm.$ct("date"),
        },
        on: {
          input: function ($event) {
            return _vm.setValue($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }